import styled from "styled-components";
import WithDirection from "../../library/helpers/rtl";

const MapContainerStyleWrapper = styled.div`
  width: 100%;
  height: auto;
  min-height: 37vh;
`;
export default WithDirection(MapContainerStyleWrapper);
